<div class="w-100-p" *ngIf="dataSource">
    <span id="ruler" class="ruler"></span>
    <mat-table #table [dataSource]="dataSource" matSort matSortActive="{{ sortBy }}" matSortDirection="{{ sortOrder }}" [class.hidden]="isLoading">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="checkbox">
            <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (change)="$event ? masterToggle() : null"
                    [checked]="selectedModuleIds.length && isAllSelected()"
                    [indeterminate]="selectedModuleIds.length && !isAllSelected()"
                >
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let module">
                <mat-checkbox [(ngModel)]="checkboxes[module.id]" (ngModelChange)="onSelectedChange(module.id)" (click)="$event.stopPropagation()"> </mat-checkbox>
            </mat-cell>
        </ng-container>

        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let module" class="avatar-cell cell-30 pl-20">
                <div #avatarCell *ngIf="module.image; else noModuleImage">
                    <img class="avatar pointer" [alt]="module.name" [src]="module.image.thumbUrl" />
                </div>
                <ng-template #noModuleImage>
                    <div #avatarCell>
                        <div class="avatar pointer module-icon-container no-image">
                            <mat-icon class="bg-icon" svgIcon="bg_illustration"></mat-icon>
                        </div>
                    </div>
                </ng-template>
            </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell class="pr-12" *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>
            <mat-cell #nameCell *matCellDef="let module" class="pr-12" fxLayout="column" fxLayoutAlign="center stretch">
                <div fxLayout="row" fxLayoutAlign="start center" class="name-with-type-icon w-100-p min-w-0 relative z-[2]">
                    <mat-icon class="icon-18 mr-8 shrink-0" [svgIcon]="module | getModuleIcon"></mat-icon>
                    <span class="text-truncate font-medium min-w-0" [tooltipIfTruncated]="module.name">{{ module.name }}</span>
                </div>
                <div #tagsHost class="tags-row w-100-p relative z-[2]" fxLayout="row" fxLayoutAlign="start center" *ngIf="module.tags.length">
                    <ng-container *ngIf="module.tags | filterTags: tagsHost:this:isLoading as visibleTags">
                        <mat-chip-set class="mr-8 py-0" [class.has-more]="visibleTags.length < module.tags.length">
                            <mat-chip
                                *ngFor="let tag of visibleTags"
                                (click)="filterByTag(tag); $event.stopPropagation()"
                                class="pointer"
                                [style.background]="tag.color"
                                [disableRipple]="true"
                            >
                                {{ tag.name }}
                            </mat-chip>
                        </mat-chip-set>

                        <ng-container *ngIf="visibleTags.length < module.tags.length">
                            <div #more class="more-tags">...</div>
                            <app-tags-card [tags]="module.tags" [target]="more" (clickedTag)="filterByTag($event)"></app-tags-card>
                        </ng-container>
                    </ng-container>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Version Column -->
        <ng-container matColumnDef="version">
            <mat-header-cell *matHeaderCellDef class="pl-24">
                <span class="text-sm leading-5 font-medium text-gray-600">{{ 'GENERAL.PROPERTY.VERSION' | translate }}</span>
            </mat-header-cell>
            <mat-cell #nameCell *matCellDef="let module" class="pl-24">
                <p class="text-truncate">{{ module.version ? module.version : '-' }}</p>
            </mat-cell>
        </ng-container>

        <!-- Module Type Column -->
        <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.TYPE' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                <p class="text-truncate" translate>
                    {{ module.type === 'e_learning' ? 'MODULE.TYPE.E-LEARNING' : 'MODULE.TYPE.BASIC' }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Start Date Column -->
        <ng-container matColumnDef="startDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.START_DATE' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                <p class="text-truncate">
                    {{ module.startDate | date: 'shortDate' }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- End Date Column -->
        <ng-container matColumnDef="endDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.END_DATE' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                <p class="text-truncate">
                    {{ module.endDate | date: 'shortDate' }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Responsible Column -->
        <ng-container matColumnDef="responsible">
            <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.RESPONSIBLE_MANAGERS' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                <p class="text-truncate">
                    <span class="value" *ngFor="let manager of module.responsibleManagers; first as isFirst">
                        {{ isFirst ? '' : ',' }}&nbsp;{{ manager.firstName }} {{ manager.lastName }}
                    </span>
                </p>
            </mat-cell>
        </ng-container>

        <!-- Participants Column -->
        <ng-container matColumnDef="numberOfParticipants">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.NUMBER_OF_PARTICIPANTS' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                <p class="text-truncate">
                    {{ module.numberOfParticipants }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Status column -->
        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="status">{{ 'GENERAL.PROPERTY.STATUS' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let module" class="status">
                <p class="text-truncate py-4 px-12 rounded-full text-xs" [style.background-color]="module.status | getStatus: moduleStatuses:'primaryColor'">
                    {{ module.status | getStatus: moduleStatuses:'translationLabel' | translate }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let module">
                <div fxFlex="row" fxLayoutAlign="end center">
                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                    </button>

                    <mat-menu #moreMenu="matMenu" xPosition="before">
                        <button mat-menu-item aria-label="remove" (click)="deleteModule(module)">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.REMOVE' | translate }}</span>
                        </button>
                    </mat-menu>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Add / Remove Action -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let module">
                <div fxFlex="row" fxLayoutAlign="end center" (click)="$event.stopPropagation()">
                    <span
                        *ngIf="!module.alreadyMember && !module.selected"
                        [matTooltip]="'GENERAL.TOOLTIP.LISTED_EXECUTION_BOOKING_DISABLED' | translate"
                        [matTooltipDisabled]="isModuleSelectable(module)"
                    >
                        <app-flat-button
                            [label]="'GENERAL.BUTTON.SELECT'"
                            (onClick)="addToList(module)"
                            [disabled]="!isModuleSelectable(module)"
                        ></app-flat-button>
                    </span>
                    <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(module)" *ngIf="module.selected"></app-white-button>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
            (click)="goToModule(module)"
            *matRowDef="let module; columns: displayedColumns"
            class="relative group pointer hover:bg-gray-50"
            [ngClass]="{ 'accent-50': checkboxes[module.id] }"
            matRipple
        >
        </mat-row>
    </mat-table>

    <div class="white" fxLayout="column" fxLayoutAlign="center center" *ngIf="isLoading">
        <div class="shimmer-container min-w-full p-0">
            <div class="shimmer p-12">
                <div class="shimmer-card !max-w-full table h-480 animate"></div>
            </div>
        </div>
    </div>

    <mat-paginator
        [persistPageSize]="pageSizePreferenceKey"
        [length]="totalCount$ | async"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
    ></mat-paginator>
</div>
